import { serviceHelper } from '../../../../config/service-helper';

export const initializeBazaarvoice = (onLoad: () => void, onError: () => void) => {
  if (serviceHelper.bazaarvoiceJsURL) {
    const BVScript = document.createElement('script');
    BVScript.src = serviceHelper.bazaarvoiceJsURL ?? '';

    BVScript.onload = () => {
      onLoad && onLoad();
    };

    BVScript.onerror = () => {
      onError && onError();
    };

    document.head.appendChild(BVScript);
  }
};
